import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Product } from '@ridango/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductService {
    constructor(@Inject('ENV') private env: any, private http: HttpClient) {}

    fetchProductsByChannel(channel: string = this.env.CHANNEL): Observable<Product[]> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/products/channel/${channel}`;

        return this.http.get(url).pipe(map((p: Product[]) => p));
    }
}
